import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpenCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { ASK_UI as UI } from "@/data/askI18n";

export const AskResult = ({ result }) => {
  const { tc } = useLang();
  const { topic, targets, faq } = result;
  return (
    <motion.div initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} className="space-y-3" data-testid="ask-result" data-topic={topic}>
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="text-muted-foreground">{tc(UI.topicLabel)}:</span>
        <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary" data-testid="ask-topic">{tc(UI[`topic.${topic}`]) || topic}</span>
      </div>
      {faq ? (
        <div className="rounded-2xl border border-[hsl(var(--gold))]/40 bg-[hsl(var(--gold))]/10 p-4" data-testid="ask-faq">
          <p className="flex items-center gap-2 text-xs font-semibold text-[hsl(var(--gold))]"><BookOpenCheck className="h-4 w-4" />{tc(UI.relatedFaq)}</p>
          <p className="mt-2 font-medium" data-testid="ask-faq-title">{tc(faq.title)}</p>
          <p className="mt-1 text-sm text-muted-foreground leading-relaxed" data-testid="ask-faq-body">{tc(faq.body)}</p>
        </div>
      ) : (
        <p className="text-xs text-muted-foreground" data-testid="ask-no-faq">{tc(UI.noFaq)}</p>
      )}
      <div className="flex flex-wrap gap-2" data-testid="ask-targets">
        {targets.map((t) => (
          <Link key={t.path} to={t.path} data-testid={`ask-target-${t.label.replace("page.", "")}`}
            className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-background px-4 py-2 text-sm font-medium hover:bg-primary hover:text-white transition-colors">
            {tc(UI.openPage)}: {tc(UI[t.label])}{t.title ? ` · ${tc(t.title)}` : ""}
            <ArrowRight className="h-4 w-4 rtl:-scale-x-100" />
          </Link>
        ))}
      </div>
    </motion.div>
  );
};
